module.exports = __webpack_public_path__ + "assets/img/driver-btn-40070e35.png";